import { render, staticRenderFns } from "./CustomWizardHeading.vue?vue&type=template&id=ea8a0c9e"
import script from "./CustomWizardHeading.vue?vue&type=script&lang=js"
export * from "./CustomWizardHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports